import React from 'react';
import PrecautionNotice from '../../components/AdminNext/PrecautionNotice';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Precaution notice — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <PrecautionNotice />
      </HeadLessLayout>
    )
  };
}

export default action;
